'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _stage = require('../stage/stage');

var _stage2 = _interopRequireDefault(_stage);

var _welcomeVideo = require('../welcome-video/welcome-video');

var _welcomeVideo2 = _interopRequireDefault(_welcomeVideo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @class Lobby
 * A component for rendering the lobby area
 * of a virtual expo, and an optional welcome video.
 * @prop {Object} stage - the properties of the associated stage
 * @prop {url} welcomeVideo - an optional welcome video url.
 */
var Lobby = function (_Component) {
  _inherits(Lobby, _Component);

  function Lobby() {
    _classCallCheck(this, Lobby);

    return _possibleConstructorReturn(this, (Lobby.__proto__ || Object.getPrototypeOf(Lobby)).apply(this, arguments));
  }

  _createClass(Lobby, [{
    key: 'componentWillMount',

    /** @method componentWillMount
      * Display the title "Lobby" in the navigation bar
      */
    value: function componentWillMount() {
      if (window.vexpo && window.vexpo.navigation && window.vexpo.navigation.setLocationName) {
        window.vexpo.navigation.setLocationName('Lobby');
      }
    }
    /** @function
     * Renders the lobby component.
     */

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_stage2.default, _extends({}, this.props.stage, { identifier: 'lobby' })),
        _react2.default.createElement(_welcomeVideo2.default, { video: this.props.welcomeVideo, identifier: 'lobby' })
      );
    }
  }]);

  return Lobby;
}(_react.Component);

exports.default = Lobby;


Lobby.propTypes = {
  stage: _propTypes2.default.object.isRequired,
  welcomeVideo: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/lobby/lobby.js
// module id = 262
// module chunks = 0